module.exports = __webpack_public_path__ + "static/rtiff-4aaff85d4a4ff626e4d374b426eeaf01.gif";